import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { BuildAvatarComponent } from './build-avatar.component';


@NgModule({
  declarations: [
    BuildAvatarComponent
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    BuildAvatarComponent
  ]
})
export class BuildAvatarModule { }
